import { render } from "./_ResultPrinting.vue?vue&type=template&id=30856672&scoped=true"
import script from "./_ResultPrinting.vue?vue&type=script&lang=js"
export * from "./_ResultPrinting.vue?vue&type=script&lang=js"

import "./_ResultPrinting.vue?vue&type=style&index=0&id=30856672&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-30856672"

export default script